<template>
  <div>
    <notifications group="foo" />
    <div class="w-100" :class="[theme === 1 ? 'total-page-bg' : 'total-page-bg-2']">
      <div v-if="isGioielleriaItalianaB2B">
        <h4 class="pt-4 color-configure mb-0 text-uppercase" :class="'color-configure-' + theme">
          {{ $t("configureJewel") }}
        </h4>
      </div>
      <div class="swiper-container justify-content-center px-0">
        <BuildYourJewelHome v-if="isGioielleriaItalianaB2B"></BuildYourJewelHome>
        <list-item section="JEWELLERY"></list-item>
        <list-item v-if="isGioielleriaItalianaB2B" section="GOLDSMITH"></list-item>
        <list-item v-if="isGioielleriaItalianaB2B" section="ACCESSORIES"></list-item>
      </div>
    </div>
    <!--
    <div class="justify-content-center" v-if="isGioielleriaItalianaB2B">
      <list-jewels-preview section="BESTSELLER"></list-jewels-preview>
    </div>
    -->
  </div>
</template>

<script>
import ListItem from "./ListItem.vue";
import { mapActions, mapState, mapMutations } from "vuex";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import StarRating from "vue-star-rating";
import ListJewelsPreview from "./ListJewelsPreview.vue";
import Vue from "vue";
import BuildYourJewelHome from "./BuildYourJewelHome.vue";

export default {
  name: "ListSection",
  components: {
    ListItem,
    Swiper,
    SwiperSlide,
    StarRating,
    ListJewelsPreview,
    BuildYourJewelHome
  },
  data() {
    return {
      position: null,
      baseImageUrl: process.env.VUE_APP_IMAGE_PATH,
      testimonials: [],
      swiperOptionsTestimonials: {
        loop: false,
        breakpoints: {
          1024: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        // },
      },
    };
  },
  computed: mapState({
    theme: (state) => state.config.theme,
    jewelList: (state) => state.list.jewels,
    searchJewel: (state) => state.list.searchJewel,
    isGioielleriaItalianaB2B: (state) => state.config.isGioielleriaItalianaB2B,
  }),
  mounted: function () {
    this.resetJewelSearch();
    this.scrollTo();
    this.setLastSelectedJewel();

    for (let i = 1; i < 10; i++) {
      this.testimonials.push({
        id: i,
        img: this.$t(i + "-logo"),
        title: this.$t(i + "-title"),
        description: this.$t(i + "-description"),
        rate: 5,
        company: this.$t(i + "-company"),
        name: this.$t(i + "-name"),
      });
    }

    // this.search(this.searchJewel);
  },
  created: function () {
    window.addEventListener("resize", Vue.setHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    ...mapActions("list", ["search"]),
    ...mapMutations("list", [
      "setJewelSearch",
      "resetJewelSearch",
      "setLastSelectedJewel",
    ]),
    ...mapMutations("detail", ["setCurrentCategory"]),
    goToDetailByButton() {
      this.$parent.goToDetail();
    },
    scrollTo() {
      window.parent.postMessage(
        {
          func: "setGioielleriaItalianaScroll",
          message: 0,
        },
        "*"
      );
    },
    selectStone(stone) {
      this.setJewelSearch({ label: "stoneColor", value: stone.id });
      this.search(this.searchJewel);
    },
    goToCategoryList(type) {
      this.scrollTo();
      if (type.productType === 'STONE') {
        //stone category
        this.$router.push({
          name: "results.stones",
        });
      } else {
        this.$router.push({
          name: "list.sublist",
          params: {
            productType: !type.websiteSectionFilter? type.productType : "JEWELLERY",
            typeId: !type.websiteSectionFilter? type.id : null,
          },
          query: {
            section: type.websiteSectionFilter 
          }
        });

        // this.$router.push({
        //   name: "list.listChoice",
        //   params: {
        //     type: type.name,
        //     typeId: type.id,
        //   },
        // });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.total-page-bg {
  background-color: var(--primary-color-1);
  width: 100%;
}

.total-page-bg-2 {
  background-color: var(--secondary-color-1);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  width: 100%;
  object-fit: cover;
}

.swiper-wrapper {
  height: 500px !important;
}

.bg-blue {
  position: relative;
}

.color-configure-1 {
  color: #fff;
  font-family: var(--secondary-font-family);
  font-style: normal;
  font-weight: 400;
  font-size: 30px;
  line-height: 40px;
  background-color: var(--primary-color-1);
}

@media only screen and (max-width: 768px) {
  .color-configure-1 {
    font-weight: 500;
    font-size: 20px;
  }

  .swiper-wrapper {
    height: 650px !important;
  }

}

.swiper-pagination-bullet-active {
  background: red !important;
}

@media screen and (min-width: 1900px) {
  .total-page-bg {
    background-color: var(--primary-color-1);
    width: 100%;
  }

  .total-page-bg-2 {
    background-color: var(--secondary-color-1);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    width: 100%;
    object-fit: cover;
  }

  .color-configure-1 {
    color: #fff;
    font-family: var(--secondary-font-family);
    font-style: normal;
    font-weight: 400;
    font-size: 30px;
    line-height: 40px;
    background-color: var(--primary-color-1);
  }

}
</style>
